import React, { Component, Fragment } from 'react';
import moment from 'moment';
import fp from 'lodash/fp';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { Skeleton } from 'elements';

import EvacuationProgressBar from 'components/evacuation-progress-bar';
import { withClientId } from 'hocs';
import {
	accumulateBlockAttendanceByHolder,
	listScheduleHoldersAssignments,
} from 'redux/modules/model/attendance';
import { cacheHolder } from 'redux/modules/model/holder';
import {
	scheduleHoldersAssignmentsSelector,
	scheduleDetailsSelector,
} from 'redux/selectors';

import { wsClient } from 'index';

import {
	getContactAttendanceForSchedule,
	listBlocks,
	listScheduleStats,
	getSchedule,
} from 'redux/modules/model/attendance';

import {
	blocksSelector,
	contactAttendanceSelector,
	detectablesSheduleStatsLoadingSelector,
	detectablesSheduleDetailsLoadingSelector,
	scheduleStatsSelector,
} from 'redux/selectors';

import ScheduleCalendar from './components/schedule-calendar';
import CommittersList from './components/committers-list';
import BlocksList from './components/blocks-list';
import BlockInfo from './components/block-info';

import './index.scss';

const singleScheduleSelector = (state, props) =>
	fp.compose(
		fp.defaultTo({}),
		fp.get('[0]'),
		fp.filter({ scheduleId: props.match.params.scheduleId }),
		fp.defaultTo([]),
		scheduleStatsSelector,
	)(state);

export class AttendanceScheduleDetail extends Component {
	static propTypes = {
		blocks: PropTypes.array,
		schedule: PropTypes.object,
		contactAttendance: PropTypes.object,
		listScheduleStats: PropTypes.func,
		listBlocks: PropTypes.func,
		match: PropTypes.object,
		getContactAttendanceForSchedule: PropTypes.func,
	};

	constructor(props) {
		super(props);

		this.state = {
			tab: {
				id: 'calendar',
				modifier: {
					blockId: null,
				},
			},
			addCommitterSelectedKey: null,
			holders: {},
			schedulesHoldersBlocksAttendance: {},
			scheduleHolderAssignments: [],
		};
	}

	componentWillMount() {
		const {
			clientId,
			match: {
				params: { scheduleId },
			},
		} = this.props;
		this.props.listBlocks({ clientId, scheduleId });
		this.props.getContactAttendanceForSchedule({ clientId, scheduleId });
	}

	componentDidMount = () => {
		const {
			clientId,
			match: {
				params: { scheduleId },
			},
			listScheduleHoldersAssignments,
			scheduleList,
			getSchedule,
		} = this.props;

		listScheduleHoldersAssignments({ clientId, scheduleId });
		this.getHolderSchedulesAssignments(clientId, scheduleId);
		getSchedule({ clientId, scheduleId });
		// if (Array.isArray(scheduleList) && scheduleList.length === 0) {
		// 	this.props.listScheduleStats({ clientId });
		// }
	};

	calendarBlockLinkHandler = blockId => {
		this.setState({
			tab: { id: 'blocks', modifier: { blockId } },
		});
	};

	getHolderSchedulesAssignments = async (clientId, scheduleId) => {
		const response = await wsClient.request({
			messageType: 'attendance.schedule.list-schedule-assignments',
			payload: {
				clientId,
				scheduleId,
			},
		});
		response.payload &&
			this.setState(() => ({
				scheduleHolderAssignments: [...response.payload],
			}));
	};

	handleSwitchTab = (id, modifier) => event => {
		event && event.preventDefault();
		this.setState({
			tab: { id, modifier },
		});
	};

	render() {
		const {
			blocks,
			contactAttendance,
			loading,
			schedule,
			history,
		} = this.props;
		const { scheduleId } = this.props.match.params;

		const startDate = moment(schedule.startTime).format('DD/MM/YYYY');
		const endDate = moment(schedule.endTime).format('DD/MM/YYYY');
		const processedCount =
			schedule.committerCount * schedule.processedBlockCount;
		const percentage = Math.round(
			(schedule.overallAttendance / (processedCount || 1)) * 100,
		);

		const tabContent = tab => {
			switch (tab.id) {
				case 'assignments':
					return (
						<CommittersList
							contactAttendance={contactAttendance}
							scheduleId={scheduleId}
						/>
					);
				case 'blocks':
					if (tab.modifier && tab.modifier.blockId)
						return (
							<BlockInfo
								scheduleId={scheduleId}
								blockId={tab.modifier.blockId}
							/>
						);
					else
						return (
							<BlocksList
								scheduleId={scheduleId}
								rowCallback={blockId => {
									this.handleSwitchTab('blocks', {
										blockId,
									})();
								}}
							/>
						);
				case 'calendar':
					return (
						<ScheduleCalendar
							blocks={blocks}
							blockLinkCallback={this.calendarBlockLinkHandler}
						/>
					);
			}
		};

		return (
			<Fragment>
				<a onClick={() => history.goBack()}>&laquo; Back</a>
				<div className="attendanceScheduleDetail section-to-print">
					<Skeleton active loading={loading}>
						<h1>{schedule.name}</h1>
						<div className="schedule-stats-summary">
							<EvacuationProgressBar
								percentage={percentage}
								tbd={!processedCount}
								warningThreshold={90}
								criticalThreshold={70}
							/>
							<p className="label">Overall Attendance to Date</p>
							<div className="stats">
								{schedule.startTime === null ? (
									<p className="stat">
										<span>Dates:</span> Unscheduled
									</p>
								) : (
									<p className="stat">
										<span>Dates:</span> {startDate} –{' '}
										{endDate}
									</p>
								)}
								<br />
								<p className="stat">
									<span>Students:</span>{' '}
									{schedule.committerCount}
								</p>
								<p className="stat">
									<span>Lectures:</span> {schedule.blockCount}
								</p>
							</div>
						</div>
					</Skeleton>
					<div className="tabs no-print">
						<Link
							className={
								this.state.tab.id === 'calendar'
									? 'current'
									: ''
							}
							onClick={this.handleSwitchTab('calendar')}
							to={`/attendance/schedules/${scheduleId}`}
						>
							Module
						</Link>
						<Link
							className={
								this.state.tab.id === 'blocks' ? 'current' : ''
							}
							onClick={this.handleSwitchTab('blocks')}
							to={`/attendance/schedules/${scheduleId}`}
						>
							Blocks
						</Link>
						<Link
							className={
								this.state.tab.id === 'assignments'
									? 'current'
									: ''
							}
							onClick={this.handleSwitchTab('assignments')}
							to={`/attendance/schedules/${scheduleId}`}
						>
							Students
						</Link>
					</div>
					{tabContent(this.state.tab)}
				</div>
			</Fragment>
		);
	}
}

const selector = createStructuredSelector({
	blocks: blocksSelector,
	schedule: scheduleDetailsSelector,
	scheduleList: scheduleStatsSelector,
	contactAttendance: contactAttendanceSelector,
	scheduleHoldersAssignments: scheduleHoldersAssignmentsSelector,
	loading: detectablesSheduleDetailsLoadingSelector,
});

const actions = {
	listScheduleStats,
	getSchedule,
	listBlocks,
	getContactAttendanceForSchedule,
	cacheHolder,
	accumulateBlockAttendanceByHolder,
	listScheduleHoldersAssignments,
};

export default compose(
	withRouter,
	connect(
		selector,
		actions,
	),
	withClientId,
)(AttendanceScheduleDetail);



// WEBPACK FOOTER //
// ./src/pages/attendance/attendance-schedule-detail/index.js